// extracted by mini-css-extract-plugin
module.exports = {"label":"MyAccountViewItem_label__GoCLo","value":"MyAccountViewItem_value__3izK0","rotation":"MyAccountViewItem_rotation__dNSPW"};